export const sportsSvgList = {
  '-1': {
    sportId: -1,
    svgKey: 'all',
  },
  '1': {
    sportId: 1,
    svgKey: 'sports',
  },
  '2': {
    sportId: 2,
    svgKey: 'basketball',
  },
  '3': {
    sportId: 3,
    svgKey: 'baseball',
  },
  '4': {
    sportId: 4,
    svgKey: 'icehockey',
  },
  '5': {
    sportId: 5,
    svgKey: 'tennis',
  },
  '6': {
    sportId: 6,
    svgKey: 'handball',
  },
  '7': {
    sportId: 7,
    svgKey: 'floorball',
  },
  '8': {
    sportId: 8,
    svgKey: 'golf',
  },
  '9': {
    sportId: 9,
    svgKey: 'motor-sport',
  },
  '10': {
    sportId: 10,
    svgKey: 'football', // Rugby
  },
  '11': {
    sportId: 11,
    svgKey: 'football', // Aussie rules
  },
  '12': {
    sportId: 12,
    svgKey: 'winter-sports',
  },
  '14': {
    sportId: 14,
    svgKey: 'football',
  },
  '16': {
    sportId: 16,
    svgKey: 'snooker',
  },
  '17': {
    sportId: 17,
    svgKey: 'tabletennis',
  },
  '18': {
    sportId: 18,
    svgKey: 'cricket',
  },
  '19': {
    sportId: 19,
    svgKey: 'darts',
  },
  '20': {
    sportId: 20,
    svgKey: 'volleyball',
  },
  '21': {
    sportId: 21,
    svgKey: 'field-hockey',
  },
  '22': {
    sportId: 22,
    svgKey: 'waterpolo',
  },
  '24': {
    sportId: 24,
    svgKey: 'sports', // futsal
  },
  '31': {
    sportId: 31,
    svgKey: 'badminton',
  },
  '35': {
    sportId: 35,
    svgKey: 'boxing',
  },
  '38': {
    sportId: 38,
    svgKey: 'Olympics', // icon mevcut değil
  },
  '42': {
    sportId: 42,
    svgKey: 'Alpine', // icon mevcut değil
  },
  '43': {
    sportId: 43,
    svgKey: 'Alpine', // icon mevcut değil
  },
  '44': {
    sportId: 44,
    svgKey: 'Biathlon', // icon mevcut değil
  },
  '45': {
    sportId: 45,
    svgKey: 'Ski Jumping', // icon mevcut değil
  },
  '58': {
    sportId: 58,
    svgKey: 'motor-sport', // "Formula E" moto-sport icon koyuldu
  },
  '72': {
    sportId: 72,
    svgKey: 'motor-sport',
  },
};
